// src/pages/tournament/TournamentActions.jsx
// What can be done with the tournament as a whole: a rematch (a copy with the same players), a file of it, a printout.
import React from 'react';
import { CopyIcon, DownloadIcon, PrinterIcon } from '../../components/icons';

function TournamentActions({ onDuplicate, onExport, onPrint, duplicating, exporting }) {
    return (
        <section className="card tournament-actions" aria-label="More">
            <h2>More</h2>
            <div className="actions-list">
                <div>
                    <button className="btn" onClick={onDuplicate} disabled={duplicating}>
                        <CopyIcon size={16} /> Duplicate
                    </button>
                    <p className="hint">A new tournament for a rematch: the same courts and singles setting and the players who are taking part, with no rounds or scores.</p>
                </div>
                <div>
                    <button className="btn" onClick={onExport} disabled={exporting}>
                        <DownloadIcon size={16} /> Export
                    </button>
                    <p className="hint">The players and settings as a file.</p>
                </div>
                <div>
                    <div className="actions-buttons">
                        <button className="btn" onClick={() => onPrint('rounds')}>
                            <PrinterIcon size={16} /> Print rounds
                        </button>
                        <button className="btn" onClick={() => onPrint('ranking')}>
                            <PrinterIcon size={16} /> Print ranking
                        </button>
                    </div>
                    <p className="hint">Opens the print dialog with the rounds and scores, or with the ranking. Choose &ldquo;Save as PDF&rdquo; for a file.</p>
                </div>
            </div>
        </section>
    );
}

export default TournamentActions;
